import { gql } from 'apollo-boost';

export const portfolioById = gql`
  query ($id: ID){
      allPortfolios(filters: {id: $id}) {
          edges {
              node {
                  name
                  portfolioId
                  description
                  status
                  isImpactSnapshot
                  years
                  investments {
                    edges {
                      node {
                        id
                        allocations {
                          edges {
                            node {
                              id
                            }
                          }
                        }
                      }
                    }
                  }
              }
          }
      }
  }
`;
